export const roundToStep = (number: number, step: number): number => Math.round(number / step) * step;

export const roundToStepLowerBoundary = (number: number, step: number): number => Math.floor(number / step) * step;

export const roundToStepUpperBoundary = (number: number, step: number): number => Math.ceil(number / step) * step;
